import { IRootState } from '../../../store'
import { ITripInformationState } from '../store/tripInformation.types'

export const getTripInformationSelector = (state: IRootState): ITripInformationState => state.tripInformation
